import './TumblerSearchResults.scss';

export { default } from './TumblerSearchResults';
